export const API_ENDPOINTS = {
    // Users
    userLogin: "/api/organization/userLogin",
    // userLogin: "/api/users/login",
    fetchEmployeesByOrganizationId: (orgId) => `/api/organization/getAllEmployeesByOrganizationId?organization_id=${orgId}`,
    // fetchEmployeesByOrganizationId: (orgId) => `/api/users/getAllEmployeesByOrganizationId?organization_id=${orgId}`,

    generateVerificationOtp: "/api/organization/generateOtp",
    verifyOtp: "/api/organization/verifyOtp",
    resetUserPassword: "/api/organization/updatePassword",
    verifyEmailToken: (token) => `/api/organization/verifyEmail?token=${token}`,
    fetchUserDetails: "/api/organization/getUserDetailsByUserId",
    fetchManagerDashboard: "/api/organization/getDashboardDetailsByManagerId",
    fetchSupervisorProjects: "/api/project/getProjectsBySupervisorId",
    fetchEmployeeProjects: "/api/project/getProjectsByEmployeeId",
    createNewProject: "/api/project/createProject",
    fetchProjectById: (projectId) => `/api/project/getProjectById/${projectId}`,
    updateProject: "/api/project/updateProjectDetails",
    fetchDepartmentsByOrganizationId: "/api/organization/getAllDepartmentsByOrganizationId",
    fetchTeamsByDepartmentId: "/api/organization/getAllTeamsByDepartmentId",
    fetchUsersByTeamId: "/api/organization/getAllUsersByTeamId",
    updateTeamAssignment: "/api/project/updateAssignTeam",
    getAllEpics: "/api/epics/getAllEpics",
    deleteEpic: "/api/epics/epics",
    createProjectEpic: "/api/epics/projects",
    fetchProductOwnersForProject: (projectId) => `/api/epics/projects/${projectId}/product-owners`,
    fetchProjectsBySupervisor: (userId) => `/api/project/getAllProjectsBySupervisor/${userId}`,
    fetchEpicById: (epicId) => `/api/epics/getEpicById/${epicId}`,
    updateEpic: (epicId) => `/api/epics/epics/${epicId}`,
    fetchTeamLeadsForOrganization: (orgId) => `/api/project/getAllTeamLeadOrManager?organization_id=${orgId}&is_team_lead=true`,
    getExternalApprovers: (orgId) => `/api/project/getExternalApprovers?organization_id=${orgId}`,
    fetchTeamLeadsOrManagers: (orgId, type) =>
        `/api/project/getAllTeamLeadOrManager?organization_id=${orgId}&${type}=true`,
    createTask: "/api/task/createTask",
    getUserStoriesByProjectOrEpic: "/api/userStories/user-stories",
    getSupervisorMainTasks: (managerId) => `/api/task/getAllMainTasksBySupervisorId/${managerId}`,
    fetchAttendanceUnderManager: "/api/organization/getAllEmployeesUnderManagerAttendance",
    getManagerLeaveRequests: "/api/organization/getLeaveRequestsByManager",
    getEmployeeLeaveTypes: (userId) => `/api/organization/getAllLeaveTypesByEmpId?user_id=${userId}`,
    approveLeaveRequest: (leaveId) => `/api/organization/approveLeave/${leaveId}`,
    createLeaveRequest: "/api/organization/createLeave",
    getLeaveInfoByEmployeeId: (userId) => `/api/organization/getAllLeaveTypesByEmpId?user_id=${userId}`,
    fetchLeaveCountsForOrganization: (organizationId) => `/api/organization/getAllLeaveTypes?organization_id=${organizationId}`,
    updateLeaveRequestStatus: (leaveId) => `/api/organization/approveLeave/${leaveId}`,
    savePushSubscription: "/api/notifications/savePushSubscription",
    getEmployeeLeaveBalance: (userId) => `/api/organization/getEmployeeLeaveBalance?user_id=${userId}`,
    getEmployeeLeaveHistory: (userId, year, month, page = 1, limit = 6) =>
        `/api/organization/getLeaveHistoryByEmployee?year=${year}&user_id=${userId}&month=${month}&page=${page}&limit=${limit}`,
    downloadHolidayListPDF: (year, orgId, locId) =>
        `/api/organization/getHolidayListPDF?year=${year}&location_id=${locId}&organization_id=${orgId}`,
    downloadHolidayListExcel: (year, orgId, locId) =>
        `/api/organization/getHolidayListExcel?year=${year}&location_id=${locId}&organization_id=${orgId}`,
    getHolidaysByYearAndMonth: (year, orgId, locId, month) => {
        const base = `/api/organization/getAllHolidaysByYearAndMonth?year=${year}&organization_id=${orgId}&location_id=${locId}`;
        return month ? `${base}&month=${month}` : base;
    },
    getAttendanceByEmployeeAndStatus: (employeeId, month, year) =>
        `/api/organization/getAttendanceByEmployeeIdByStatus?employee_id=${employeeId}&month=${month}&year=${year}`,
    fetchStoriesByProjectAndEpic: (projectId, epicId = null) => {
        const baseUrl = `/api/userStories/epics/${projectId}/user-stories`;
        return epicId ? `${baseUrl}?epic_id=${epicId}` : baseUrl;
    },
    fetchUserTaskDetails: (id) => `/api/task/getManagerTaskById?task_id=${id}`,
    updateUserTaskById: "/api/task/updateTask",
    deleteUserTaskById: `/api/task/deleteTask`,
    createSubTask: `/api/task/createSubTask`,
    fetchManagerPerformanceDashboardStats: (userId) => `/api/performancemanagement/stats?reporting_manager_id=${userId}`,
    fetchEmployeesByPerformanceStatus: (userId, status) =>
        `/api/performancemanagement/getEmployeesByStatus?status=${status}&reporting_manager_id=${userId}`,
    fetchAppraisalsByStatus: (userId, status, goalPeriod) =>
        `/api/performancemanagement/getAppraisalsByStatus?status=${status}&report_manager_id=${userId}&goal_period=${goalPeriod}`,
    fetchEmployeeDashboardStats: (userId) =>
        `/api/performancemanagement/getEmployeeDashboardStats?reporting_manager_id=${userId}`,
    fetchAppraisalsByManager: (userId, goalPeriod = "Yearly") =>
        `/api/performancemanagement/getAppraisalsByStatus?report_manager_id=${userId}&goal_period=${goalPeriod}`,
    // 65----71
    fetchAppraisalDashboardStats: (userId) =>
        `/api/performancemanagement/getAppraisalDashboardStats?reporting_manager_id=${userId}`,
    fetchEmployeeRatingsAndFeedback: (employeeId, year, period) =>
        `/api/performancemanagement/getRatingsAndFeedback?emp_id=${employeeId}&appraisal_year=${year}&appraisal_period=${period}`,
    fetchAppraisalById: (appraisalId) =>
        `/api/performancemanagement/getAppraisalById?appraisal_id=${appraisalId}`,
    createRatings: "/api/performancemanagement/addRatings",
    fetchEmployeeGoals: (employeeId) => `/api/empGoal/get_All_goals_by_emp_id?emp_id=${employeeId}`,
    fetchGoalById: (goalId) => `/api/empGoal/get_EmpGoal_by_id?id=${goalId}`,
    fetchGoalCommentsById: (goalId) => `/api/empGoal/get_goal_comments_by_id?goal_id=${goalId}`,
    updateGoal: "/api/empGoal/update_EmpGoal",
    addGoalComment: "/api/empGoal/add_goal_comment",
    fetchEmployeeGoalCount: (empId) => `/api/empGoal/total_goal_count?emp_id=${empId}`,
    markAttendance: '/api/organization/markAttendance',
    getTodayAttendanceRecord: (userId) => `/api/organization/getTodayAttendanceRecordForEmployee?user_id=${userId}`,
    updateTodayAttendance: '/api/organization/updateAttendanceByToday',
    fetchHrDashboardData: (organizationId) => `/api/organization/getHrDashboardData?organization_id=${organizationId}`,

    fetchDesignationsByTeamId: (teamId) => `/api/organization/getAllDesignationsByTeamId/${teamId}`,
    createUser: "/api/organization/userSignup",
    fetchTeamLeadsAndManagers: (organizationId) => `/api/project/getAllTeamLeadOrManager?organization_id=${organizationId}&is_manager=true&is_team_lead=true`,
    fetchLocationsByOrganizationId: (orgId) => `/api/organization/getAllLocationsByOrgId/${orgId}`,
    fetchRolesByOrganizationId: (organizationId) => `/api/organization/getAllRolesByOrgId?organization_id=${organizationId}`,
    downloadEmployeeListExcel: (organizationId, status, locationId) => `/api/organization/getEmployeeListExcel?organization_id=${organizationId}&status=${status}&location_id=${locationId}`,
    downloadEmployeeListPDF: (organizationId, status, locationId) => `/api/organization/getEmployeeListPDF?organization_id=${organizationId}&status=${status}&location_id=${locationId}`,
    fetchNotificationCount: (userId) => `/api/notifications/count?user_id=${userId}`,
    fetchUserNotifications: (userId) => `/api/notifications/getNotifications?userId=${userId}`,
    markNotificationsAsRead: "/api/notifications/mark-read",
    updateEmployeeProfile: (userId) => `/api/organization/updateEmployeeDetails?userId=${userId}`,
    uploadProfilePic: (userId) => `/api/organization/uploadProfilePic?userId=${userId}`,
    fetchEmployeeDashboard: (userId, year, month) => `/api/organization/getDashboardDetailsByEmployeeId?userId=${userId}&year=${year}&month=${month}`,
    fetchTasksByEmployeeId: "/api/task/getAllTasksByEmployeeId",
    updateEmployeeTaskStatus: "/api/task/updateTaskStatusByEmployee",
    uploadAttachmentToTask: (taskId) => `/api/task/attachmentUpload/${taskId}`,
    getTeamLeadsAndManagers: (orgId) => `/api/project/getAllTeamLeadOrManager?organization_id=${orgId}&is_manager=true&is_team_lead=true`,
    uploadUsersByCsv: '/api/organization/userSignupByCsv',
    updateEmployeePersonalContact: '/api/hr/updatePersonalContactTab',
    deleteProjectById: (projectId) => `/api/project/deleteProject/${projectId}`,
    getAllEmploymentTypes: (orgId) => `/api/hr/getAllEmploymentTypes/${orgId}`,
    getPayrollSettingsByEmployeeId: (userId) => `/api/employeePayrollSettings/getPayrollSettingsById?employeePersonalId=${userId}`,
    updatePayrollSettings: "/api/employeePayrollSettings/updatePayrollSettings",
    createPayrollSettings: "/api/employeePayrollSettings/createPayrollSettings",
    updateEmployeeFinanceAndStatutory: "/api/hr/updateEmployeeFinanceAndStatutory",
    getAllEmployeeDocumentsByUserId: (userId) => `/api/hr/getAllEmployeeDocuments/${userId}`,
    uploadEmployeeFiles: "/api/hr/documentsUpload",
    deleteEmployeeDocument: (documentId) => `/api/hr/deleteEmployeeDocument/${documentId}`,
    getAllLeavePoliciesByOrganizationId: (orgId) => `/api/hr/getAllLeavePolicies/${orgId}`,
    getAllShiftTypesByOrganizationId: (orgId) => `/api/hr/getAllShiftTypes/${orgId}`,
    getAllAttendanceSourcesByOrganizationId: (orgId) => `/api/hr/getAllAttendanceSources/${orgId}`,
    getAllHolidayPoliciesByOrganizationId: (orgId) => `/api/hr/getAllHolidayPolicies/${orgId}`,
    updateEmployeePolicyAssignment: "/api/hr/updateEmployeePolicyAssignment",
    fetchExitRehireDetails: (userId) => `/api/hr/getEmployeeExitRehireDetails/${userId}`,
    getIncomeTaxForm: (empId, financialYear) => `/api/income-tax/get-form12A?employeePersonalId=${empId}&financialYear=${financialYear}`,
    calculateIncomeTax: "/api/income-tax/calculate-tax",
    getTaxSummaryByFinancialYear: (empId, financialYear) => {
        const query = new URLSearchParams({ employeePersonalId: empId || '', financialYear: financialYear || '' });
        return `/api/income-tax/tax-summary?${query.toString()}`;
    },
    getEmployeeTaxDeclaration: (empId, financialYear) => `/api/income-tax/getDeclarationById?employeePersonalId=${empId}&financialYear=${financialYear}`,
    getTaxOptions: "/api/income-tax/tax-options",
    declareEmployeeInvestments: "/api/income-tax/declare-investments",
    uploadInvestmentProof: "/api/income-tax/upload-proof",
    uploadForm: "/api/income-tax/upload-form12A",
    submitTaxRegimeChangeRequest: "/api/income-tax/submit-regime-change-request",
    getEmployeePayslipByDateRange: (
        startMonth,
        startYear,
        endMonth,
        endYear,
        employeeId,
        departmentId
    ) => {
        const query = new URLSearchParams({
            startMonth: startMonth || '',
            startYear: startYear || '',
            endMonth: endMonth || '',
            endYear: endYear || '',
            employeeId: employeeId || '',
            departmentId: departmentId || ''
        })
        return `/api/batchPayroll/getEmployeePayslip?${query.toString()}` },
    fetchEmployeeReimbursements: (empId) => `/api/reimbursements/getReimbursementByemployeeId?employeePersonalId=${empId}`,
    createEmployeeReimbursement: "/api/reimbursements/createReimbursement",
    getDailyAttendanceOverview: (orgId) => `/api/organization/getTodayAttendanceOverview/${orgId}`,
    getHRAttendanceEmployeesByDateAndOrgId: (date, orgId) => `/api/organization/getAllEmployeesForHrAttendence?Date=${date}&organization_id=${orgId}`,
    getDayWiseAttendancePDF: (params) => `/api/organization/getDayWiseAttendancePDF`,
    getDayWiseAttendanceExcel: (params) => `/api/organization/getDayWiseAttendanceExcel`,
    downloadMonthlyAttendancePDF: (params) => '/api/organization/getMonthlyAttendancePDF',
    downloadMonthlyAttendanceExcel: (params) => '/api/organization/getMonthlyAttendanceExcel',
    getEmployeeMonthlyAttendanceOverviewForHR: (params) => `/api/organization/getAttendanceOverviewByEmployeeIdByMonthForHr`,
    downloadEmployeeDailyAttendancePDF: (params) => `/api/organization/getEmployeeDailyAttendancePDF`,
    downloadEmployeeDailyAttendanceExcel: (params) => `/api/organization/getEmployeeDailyAttendanceExcel`,
    getAllLeaveRequestsByOrganizationId: (params) => `/api/organization/getAllLeaveRequestsByOrgId`,
    updateEmployeeLeaveBalance: "/api/organization/updateLeaveBalance",
    getAllLeaveBalancesByOrganizationId: (orgId) => `/api/organization/getAllLeaveBalancesByOrgId?organization_id=${orgId}`,
    getAllLeaveTypesByEmployeeId: (empId) => `/api/organization/getAllLeaveTypesByEmpId?user_id=${empId}`,
    getAllLeaveHistoryByOrganizationId: `/api/organization/getAllLeaveHistoryByOrgId`,
    downloadLeaveHistoryPDF: (params) => `/api/organization/getLeaveHistoryPDF`,
    downloadLeaveHistoryExcel: (params) => `/api/organization/getLeaveHistoryExcel`,
    updateHolidayById: (holidayId) => `/api/organization/updateHoliday/${holidayId}`,
    createHoliday: "/api/organization/createHoliday",
    deleteHolidayById: (holidayId) => `/api/organization/deleteHoliday/${holidayId}`,
    updateLeaveTypeById: (leaveTypeId) => `/api/organization/updateLeaveType/${leaveTypeId}`,
    createLeaveType: "/api/organization/createLeaveType",
    deleteLeaveTypeById: (leaveTypeId) => `/api/organization/deleteLeaveType/${leaveTypeId}`,
    getPayrollReportDashboard: "/api/payrollReportTypes/dashboard",
    getRecentActivities: (page, limit) => `/api/recentActivity/getAllActivities?page=${page}&limit=${limit}`,
    getPayrollsByHrId: (hrId) => `/api/payrollCompensation/getAllPayrollsByHrId?hr_id=${hrId}`,
    getPayrollCompensationByEmployeeId: (empId) => `/api/payrollCompensation/getPayrollCompensationById?employeePersonalId=${empId}`,
    createPayrollCompensation: "/api/payrollCompensation/createPayrollCompensation",
    calculatePayrollAllowances: "/api/payrollCompensation/calculateAllowances",
    previewPayrollCompensation: "/api/payrollCompensation/previewPayrollCompensation",
    getNotes: "/api/notes/getNotes",
    updateNote: "/api/notes/updateNote",
    verifyIncomeTaxProof: "/api/income-tax/admin/verify-proof",
    getReimbursementsByHrId: (hrId) => `/api/reimbursements/getReimbursements?hr_id=${hrId}`,
    createReimbursement: "/api/reimbursements/createReimbursement",
    deleteReimbursementById: (id) => `/api/reimbursements/deleteReimbursementById?id=${id}`,
    getUpcomingPayrollMonths: (includeNextFY = true) => `/api/reimbursements/getUpcomingPayrollMonths?includeNextFY=${includeNextFY}`,
    updateReimbursementById: "/api/reimbursements/updateReimbursementById",
    getBatchOverview: (year, month) => `/api/batchPayroll/getBatchOverview?year=${year}&month=${month}`,
    updateBatchPayrollById: "/api/batchPayroll/updateBatchPayrollByid",
    createBatchPayroll: "/api/batchPayroll/createBatchPayroll",
    getPayrollMonthsDropdown: "/api/batchPayroll/getPayrollMonthsDropdown",
    getLeaveEncasementByHR: "/api/reimbursements/getLeaveEncashmentByHR",
    getLeaveEncasement: "/api/reimbursements/getLeaveEncashment",
    updateLeaveEncasement: "/api/reimbursements/updateLeaveEncashment",
    getEmployeeBankingAndStatutoryDetails: "/api/reimbursements/getEmployeeBankingAndStatutoryDetails",
    getBatchPayrollSummary: (year, month) => `/api/batchPayroll/getBatchPayrollSummary?year=${year}&month=${month}`,
    updateBatchPayrollLock: "/api/batchPayroll/updateBatchPayrollLock",
    getBatchPayrollById: (id) => `/api/batchPayroll/getBatchPayrollByid?id=${id}`,
    disbursePayrollPayouts: "/api/payrollPayment/disbursePayrollPayouts",
    updateBatchPayrollLockAndFinalize: "/api/batchPayroll/updateBatchPayrollLockandfinalized",
    getTransactionDetails: (queryString) => {
        return queryString
            ? `/api/payrollPayment/getTransactionDetails?${queryString}`
            : "/api/payrollPayment/getTransactionDetails";
    },
    getAllDepartments: "/api/reimbursements/getAllDepartments",
    getPayrollReportByType: (reportType) => `/api/payrollReportTypes/${reportType}`,
    getPayrollReportTypesDropdown: "/api/payrollReportTypes/dropdown",
    getPayrollCompensationConstants: "/api/payrollCompensation/constants",
    updatePayrollCompensationConstants: "/api/payrollCompensation/constants/update",
    deletePayrollCompensationConstants: "/api/payrollCompensation/constants/delete",
    getAdminTaxBreakdowns: "/api/income-tax/admin/tax-breakdowns",
    manageTaxBreakdown: "/api/income-tax/admin/manage-tax-breakdown",
    deleteTaxBreakdownById: (id) => `/api/income-tax/admin/delete-tax-breakdown/${id}`,
    resendEmailVerification: "/api/auth/resend-email-verification",
    getGoalsGroupedByTitle: "/api/performanceHr/getGoalsGroupedByTitle",
    fetchAllTasks: (params) => {
        const { search, project_id, epic_id, user_story_id, work_type, priority, status, user_role, user_id, include_subtasks, page, limit, assignee } = params;
        const query = new URLSearchParams({
            search: search || "",
            project_id: project_id || "",
            epic_id: epic_id || "",
            user_story_id: user_story_id || "",
            work_type: work_type || "",
            priority: priority || "",
            status: status || "",
            user_role: user_role || "", // Matches backend destructuring
            user_id: user_id || "",     // Matches backend destructuring
            page: page || 1,
            limit: limit || 10,
            assignee: assignee || "",
            include_subtasks: include_subtasks || false
        }).toString();

        return `/api/task/getAllTasks?${query}`;
    },
    fetchTaskById: (id) => `/api/task/getTaskById/${id}`,
    getEmployeeTasks: (empId) => `/api/task/getTasksByEmployee?employeeId=${empId}`,
    uploadTaskAttachments: "/api/task/upload-attachments",
    getActiveTasksForEmployee: (employeeId, projectId) => `/api/task/active?employeeId=${employeeId}&projectId=${projectId}`,
    createEmployeeExit: "/api/hr/initiateEmployeeExit",
    getEmployeeExitAndRehireDetails: (empId) => `/api/hr/getEmployeeExitRehireDetails/${empId}`,
    reactivateEmployee: "/api/hr/rehireEmployee",

    // Dashboard counts
    getManagerDashboardCounts: "/api/dashboard/getManagerDashboardStats",
    getHrDashboardCounts: "/api/dashboard/getHrDashboardStats",
    getTeamLeadDashboardCounts: "/api/dashboard/getTeamLeadDashboardStats",
    getEmployeeDashboardCounts: "/api/dashboard/getEmployeeDashboardStats",
    getExternalApproverDashboardCounts: "/api/dashboard/getExternalApproverDashboardStats",

    // Story Management
    createUserStory: "/api/user-stories/create",
    fetchStories: "/api/user-stories/all",
    fetchUserStoryDetails: (id) => `/api/user-stories/${id}`,
    updateUserStoryById: (id) => `/api/user-stories/${id}`,
    deleteUserStoryById: (id) => `/api/user-stories/${id}`,

    // Timesheet Management — TODO: update base paths when backend is ready
    getEmployeeTimesheets: (userId, year, month, status, page = 1, limit = 10) => {
        const query = new URLSearchParams({ user_id: userId, year, month: month || '', status: status || '', page, limit }).toString();
        return `/api/timesheets/getTimesheetsByEmployee?${query}`;
    },
    getTimesheetStats: (userId) => `/api/timesheets/stats?user_id=${userId}`,
    createTimesheet: '/api/timesheets/create',
    updateTimesheet: (id) => `/api/timesheets/update/${id}`,
    deleteTimesheet: (id) => `/api/timesheets/delete/${id}`,
    submitTimesheet: (id) => `/api/timesheets/submit/${id}`,
    uploadTimesheetAttachments: '/api/timesheets/upload-attachments',

    // HR Timesheet Endpoints — TODO: connect when backend is ready
    getAllTimesheets: (year, month, status, dept, employeeId, page = 1, limit = 10, sortBy, sortOrder) => {
        const params = { year, month: month || '', status: status || '', dept: dept || '', employee_id: employeeId || '', page, limit };
        if (sortBy) params.sortBy = sortBy;
        if (sortOrder) params.sortOrder = sortOrder;
        const query = new URLSearchParams(params).toString();
        return `/api/timesheets/getAllTimesheets?${query}`;
    },
    getHRTimesheetStats: () => `/api/timesheets/hr-stats`,
    getTimesheetConfig: () => `/api/timesheets/config`,
    saveTimesheetConfig: () => `/api/timesheets/config`,
    getAuditLogs: (from, to, action, employeeId, name, page = 1, limit = 25) => {
        const query = new URLSearchParams({ from: from || '', to: to || '', action: action || '', employee_id: employeeId || '', name: name || '', page, limit }).toString();
        return `/api/timesheets/audit-logs?${query}`;
    },
    getTimesheetReports: (year, month, dept) => {
        const query = new URLSearchParams({ year, month: month || '', dept: dept || '' }).toString();
        return `/api/timesheets/reports?${query}`;
    },
    getWeeklyEmployeeSummary: (year, month, dept) => {
        const query = new URLSearchParams({ year, month: month || '', dept: dept || '' }).toString();
        return `/api/timesheets/reports/weekly-summary?${query}`;
    },
    exportTimesheets: () => `/api/timesheets/export`,
    exportHRAuditLogs: () => `/api/timesheets/audit/export`,

    // TODO: Manager Timesheet Endpoints — replace with real API when backend is ready
    getTeamTimesheets: (managerId, year, month, status, employeeId, page = 1, limit = 10) => {
        const query = new URLSearchParams({ manager_id: managerId, year, month: month || '', status: status || '', employee_id: employeeId || '', page, limit }).toString();
        return `/api/timesheets/team?${query}`;
    },
    getManagerTimesheetStats: (managerId) => `/api/timesheets/manager-stats?manager_id=${managerId}`,
    approveTimesheet: (id) => `/api/timesheets/${id}/approve`,
    rejectTimesheet: (id) => `/api/timesheets/${id}/reject`,
    editTeamTimesheet: (id) => `/api/timesheets/${id}/manager-edit`,
    sendEntriesToLevel2: (id) => `/api/timesheets/${id}/send-entries-to-level2`,
    bulkApproveTimesheets: '/api/timesheets/bulk-approve',
    bulkRejectTimesheets: '/api/timesheets/bulk-reject',
    getTimesheetAuditTrail: (id) => `/api/timesheets/${id}/audit`,
    getTimesheetById: (id) => `/api/timesheets/${id}`,
    getL2AssignedTimesheets: '/api/timesheets/l2-assigned',
    getL2PendingEntries: '/api/timesheets/l2-pending',
    getL2ApproverItems: (approverId) => `/api/timesheets/l2-approver/${approverId}/items`,
    l2ApproveEntry: (entryId) => `/api/timesheets/entries/${entryId}/l2-approve`,
    l2RejectEntry: (entryId) => `/api/timesheets/entries/${entryId}/l2-reject`,
    l2EditEntry: (entryId) => `/api/timesheets/entries/${entryId}/l2-edit`,
    companyL2ApproveTimesheet: (id) => `/api/timesheets/${id}/company-l2-approve`,
    companyL2RejectTimesheet: (id) => `/api/timesheets/${id}/company-l2-reject`,

    // External approver — public, tokenized email-link flow (no login required)
    getApprovalLinkTimesheet: (id, token) => `/api/timesheet-approval/${id}?token=${encodeURIComponent(token)}`,
    approveApprovalLinkTimesheet: (id, token) => `/api/timesheet-approval/${id}/approve?token=${encodeURIComponent(token)}`,
    rejectApprovalLinkTimesheet: (id, token) => `/api/timesheet-approval/${id}/reject?token=${encodeURIComponent(token)}`,
    approveApprovalLinkEntry: (entryId, token) => `/api/timesheet-approval/entries/${entryId}/approve?token=${encodeURIComponent(token)}`,
    rejectApprovalLinkEntry: (entryId, token) => `/api/timesheet-approval/entries/${entryId}/reject?token=${encodeURIComponent(token)}`,
    editApprovalLinkEntry: (entryId, token) => `/api/timesheet-approval/entries/${entryId}/edit?token=${encodeURIComponent(token)}`,
    getTeamAnalytics: (managerId, year, month) =>
        `/api/timesheets/analytics?manager_id=${managerId}&year=${year}&month=${month}`,

    // leave Management
    fetchAllLeaveRequests: (params) => {
        const { report_manager_id, organization_id, search, status, month, year, page, limit } = params;

        const query = new URLSearchParams({
            organization_id: organization_id || "",
            report_manager_id: report_manager_id || "",
            search: search || "null",
            status: status || "PENDING",
            month: month || "null",
            year: year || "null",
            page: page || "null",
            limit: limit || "null"
        }).toString();

        return `/api/leaveManagement/requests?${query}`;
    },
    fetchLeaveRequestsByTeamLead: (teamLeadId, params = {}) => {
        const { search, status, month, year, page, limit } = params;

        const query = new URLSearchParams({
            teamLeadId: teamLeadId,
            search: search || "null",
            status: status || "PENDING",
            month: month || "null",
            year: year || "null",
            page: page || "null",
            limit: limit || "null"
        }).toString();

        return `/api/leaveManagement/team-lead/leave-requests?${query}`;
    },



};
